module.exports = __webpack_public_path__ + "static/logo-840ee4b52743debcfad206c79f02a981.png";